import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PreLogService } from '../../services/pre-log.service';
import { IPreLog } from "../../interfaces/pre-log";
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from '../../services/configuration.service';
import { IBranding } from '../../interfaces/branding';
import { ErrorService } from '../../services/error.service';
import { IExternalLinks } from '../../interfaces/external-links';

@Component({
    selector: 'app-pre-log-detail',
    templateUrl: './pre-log-detail.component.html',
    styles: [],
    standalone: false
})
export class PreLogDetailComponent implements OnInit {
  public preLog: IPreLog;
  public errorMessage: string;
  public branding: IBranding;
  public externalLinks: IExternalLinks;

  constructor(private readonly titleService: Title,
    private readonly route: ActivatedRoute,
    private readonly preLogService: PreLogService,
    private readonly configService: ConfigurationService,
    private readonly errorService: ErrorService) { }

  ngOnInit(): void {
    this.titleService.setTitle("DNA Sample Pre-Log Details");

    let preLogId = parseInt(this.route.snapshot.paramMap.get("id"));
    this.preLogService.getPreLog(preLogId)
      .subscribe(data => {
        var preLogConverted: IPreLog = {
          id: 0, // Not Used
          kitBarcode: data.kitBarcode,
          dateEntered: this.ConvertToNgbStruct(data.dateEntered),
          enteredBy: data.enteredBy,
          agencyId: 0, // Not Used
          agencyName: data.agencyName,
          lastName: data.lastName,
          firstName: data.firstName,
          middleInitial: data.middleInitial,
          nameSuffix: data.nameSuffix,
          aliases: data.aliases,
          genderCode: null, // Not Used
          gender: data.gender,
          raceId: 0, // Not Used
          race: data.race,
          dateOfBirth: this.ConvertToNgbStruct(data.dateOfBirth),
          ssn: data.ssn,
          sid: data.sid,
          sourceId: 0, // Not Used
          reasonForCollection: data.reasonForCollection,
          qualifyingCharge: data.qualifyingCharge,
          qcDropdown: 0, // Not Used
          qcTextbox: null, // Not Used
          qcDropdown2: 0, // Not Used
          qcFreeText: null, // Not Used
          state: data.state,
          arrestingOfficer: data.arrestingOfficer,
          dcn: data.dcn,
          docNumber: data.docNumber,
          collectedBy: data.collectedBy,
          dateCollected: this.ConvertToNgbStruct(data.dateCollected)
        }
        this.preLog = preLogConverted;
      }, error => {
          this.errorMessage = this.errorService.getErrorMessage(error);
      });

    this.configService.getBranding()
      .subscribe(
        data => this.branding = data,
        error => this.errorMessage = this.errorService.getErrorMessage(error)
      );

    this.configService.getExternalLinks()
      .subscribe(
        data => this.externalLinks = data,
        error => this.errorMessage = this.errorService.getErrorMessage(error)
      );
  }

  public print(e: MouseEvent): void {
    e.preventDefault();
    window.print();
  }

  private ConvertToNgbStruct(date: Date): NgbDateStruct {
    return date ? { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } : null;
  }
}
